import { Link, usePage } from "@inertiajs/react"
import { Lock, LogOut } from "lucide-react"

import { Avatar } from "./Avatar"
import { signOut } from "@/lib/orderActions"
import { cn } from "@/lib/utils"

// The signed-in customer's account block, pinned to the sidebar foot. The whole
// block links to Profile; a separate button ends the session. When the customer
// is an active Insider, a small red lock badge decorates their OWN avatar (seam
// #1 — only ever the customer's, never a freelancer's). The badge slot + its
// gating are real here; the full Insider visual polish rides with the Insider
// item.
export default function NavAccountBlock({ auth }) {
  const { url } = usePage()
  const active = url.startsWith("/profile")

  // Sign-out is a full, session-ending navigation (shared hard-navigation helper):
  // Devise DELETE /users/sign_out ends the session then redirects through to the
  // sign-in page. A plain Inertia router.delete follows that redirect as an XHR
  // and never leaves the page, so this routes through the shared form-submit
  // signOut (tuw-app:P-007 — one path for every sign-out button).

  return (
    <div
      className={cn(
        "mt-1 flex items-center gap-2 rounded-[10px] px-[9px] py-2 transition-colors",
        active ? "bg-[image:var(--nav-active-bg)]" : "hover:bg-card"
      )}
    >
      <Link
        href="/profile"
        aria-current={active ? "page" : undefined}
        className="flex min-w-0 flex-1 items-center gap-2 no-underline"
      >
        <span className="relative shrink-0">
          <Avatar initials={auth?.initials ?? "?"} name={auth?.name} src={auth?.avatarUrl} size={34} me />
          {auth?.insider && (
            <span
              title="Insider"
              aria-label="Insider"
              className="absolute -right-0.5 -bottom-0.5 grid size-[15px] place-items-center rounded-full border-2 border-sidebar bg-primary text-primary-foreground"
            >
              <Lock className="size-[8px]" strokeWidth={2.5} />
            </span>
          )}
        </span>

        <span className="flex min-w-0 flex-col leading-tight">
          <span className="truncate text-[13px] font-semibold text-foreground">{auth?.name}</span>
          {auth?.username && <span className="truncate text-[11.5px] text-ink-3">@{auth.username}</span>}
        </span>
      </Link>

      <button
        type="button"
        onClick={signOut}
        title="Sign out"
        aria-label="Sign out"
        className="grid size-8 shrink-0 place-items-center rounded-[8px] text-ink-3 transition-colors hover:bg-card hover:text-foreground"
      >
        <LogOut className="size-[16px]" strokeWidth={1.9} />
      </button>
    </div>
  )
}
